{
  "title": "Відвідуваність",
  "description": "Позначайте, хто був на уроці, і дивіться, як клас відвідує заняття за період.",
  "class": "Клас",
  "selectClass": "Оберіть клас",
  "noClasses": {
    "title": "Немає класів для показу",
    "teacherText": "Ви поки не ведете жодного класу — відвідуваність позначають для кожного класу окремо.",
    "adminText": "У школі ще немає класів. Відвідуваність можна позначати, щойно з’явиться перший.",
    "action": "До класів"
  },
  "from": "Від",
  "to": "До",
  "clearRange": "Очистити дати",
  "loadFailed": "Не вдалося завантажити відвідуваність.",
  "lessons": {
    "title": "Уроки за цей період",
    "empty": "Для цього класу не заплановано жодного уроку.",
    "marked": "Позначено",
    "unmarked": "Не позначено",
    "partial": "Позначено частково",
    "markedCount": "{{marked}} з {{total}} учнів",
    "open": "Позначити",
    "reopen": "Змінити позначки",
    "emptyFiltered": "У цей проміжок дат не потрапив жоден урок. Очистіть дати, щоб побачити всі уроки."
  },
  "totals": {
    "title": "Підсумок за період",
    "percent": "Відвідуваність {{percent}}%",
    "noData": "Ще нічого не позначено."
  },
  "statuses": {
    "present": "Присутній",
    "absent": "Відсутній",
    "late": "Запізнився",
    "excused": "Поважна причина"
  },
  "marking": {
    "title": "{{lesson}}",
    "back": "Назад до уроків",
    "roster": "Список класу",
    "emptyRoster": "До цього класу ще нікого не зараховано.",
    "statusFor": "Відвідуваність: {{pupil}}",
    "note": "Примітка",
    "notePlaceholder": "Необов’язкова примітка",
    "noteFor": "Примітка для {{pupil}}",
    "markAllPresent": "Усі присутні",
    "save": "Зберегти відвідуваність",
    "saved": "Відвідуваність збережено.",
    "saveFailed": "Не вдалося зберегти відвідуваність.",
    "summary": "Присутні {{present}} · Запізнились {{late}} · З поважної причини {{excused}} · Відсутні {{absent}}"
  },
  "export": {
    "csv": "Експорт CSV",
    "xlsx": "Експорт XLSX",
    "started": "Файл завантажується.",
    "failed": "Не вдалося завантажити файл."
  }
}
